import { getIsLoggedIn } from '@account/entity';
import { selectHasMultiAccount } from '@consumer/entity';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { AppConfigService } from '@core/config-angular';
import type { JssNavItem } from '@core/jss-models';
import {
  getServiceNavigationRootName,
  JssRouteBuilderService,
} from '@core/jss-routing';
import { getSettingsValue } from '@core/settings';
import { getCustomerName } from '@customer/entity';
import {
  ActiveLinkService,
  getNavigationItems,
  showCategories,
} from '@core/navigation-store';
import { select, Store } from '@ngrx/store';
import { AsyncPipe } from '@angular/common';

import { HeaderToolsComponent } from '../header-tools/header-tools.component';

@Component({
  selector: 'wl-header-tools-container',
  templateUrl: './header-tools-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [HeaderToolsComponent, AsyncPipe],
})
export class HeaderToolsContainerComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() loginUrl?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() loginUrlLabel?: string;

  @Output()
  navItemClick = new EventEmitter<JssNavItem>();

  readonly #store$ = inject(Store<any>);
  public readonly logoutButtonText$ = this.#store$.pipe(
    select(getSettingsValue<string>('auth', 'logoutButtonText'))
  );
  public readonly switchAccountButtonText$ = this.#store$.pipe(
    select(getSettingsValue<string>('auth', 'switchAccountButtonText'))
  );
  public readonly isLoggedIn$ = this.#store$.pipe(select(getIsLoggedIn));
  public readonly hasMultipleAccounts$ = this.#store$.pipe(
    select(selectHasMultiAccount)
  );
  public title$ = this.#store$.pipe(getServiceNavigationRootName);
  public readonly fullName$ = this.#store$.pipe(select(getCustomerName));
  readonly #appConfigService = inject(AppConfigService);
  public readonly logoutEndpointUrl = `${this.#appConfigService.basePath}/auth/logout`;
  public readonly switchAccountEndpointUrl = `${this.#appConfigService.basePath}/auth/select-account`;
  readonly #urlBuilder = inject(JssRouteBuilderService);
  readonly #activeLinkService = inject(ActiveLinkService);
  public readonly navItems$ = this.#store$.pipe(
    getNavigationItems(this.#store$, this.#urlBuilder, this.#activeLinkService)
  );
  public readonly showCategories$ = this.#store$.pipe(
    showCategories(this.#store$, this.#urlBuilder, this.#activeLinkService)
  );
}
